import styled from "styled-components";

import { useQuery, useQueryClient } from 'react-query';

import { useNavigate } from "react-router-dom";
import { Drawer } from "@mui/material";
import React, { useCallback, useState } from 'react';
import { useEffect } from 'react';
import { getMenu } from "../../common/util";
import theme from "../../styles/theme";
import { useGetMenuStatus } from "../../interfaces/common";
import { useLogout } from "../../interfaces/auth";

const MenuLeft = styled.div`
    width: 200px;
    height: 100vh;
    height: -webkit-fill-available;
    height: fill-available;
    // border:1px solid red;
    padding: 1rem 2rem;
    background: ${theme.color.white[100]};
    // border-right: 1px solid ${theme.color.black[10]};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    h2 {
        text-align: center;
        margin: 0;
        color: ${theme.color.black[60]};
        font-size: ${theme.fontSize.md};
        font-weight: 800;
        cursor: pointer;
    }
    div > a, div > span{
        text-decoration: none;
        color: ${theme.color.black[80]};
        font-size: ${theme.fontSize.bmd};
        cursor: pointer;
        &:hover {
            color: ${theme.color.black[100]};
        }
        transition: color 400ms ease-in-out, transform 400ms ease-in-out;
    }
    div > div > a, div > div > span {
        text-decoration: none;
        display: block;
        padding: 0.25rem 1.5rem;
        color: ${theme.color.black[60]};
        font-size: ${theme.fontSize.base};
        &:hover {
            color: ${theme.color.black[100]};
        }
        transition: color 400ms ease-in-out, transform 400ms ease-in-out;
    }
    svg {
        &:hover {
            path {
                stroke: ${theme.color.black[100]};
            }
        }
        transition: all 400ms ease-in-out, transform 400ms ease-in-out;
    }
`;

const Menu = () => {

    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { data : menuStatus } = useGetMenuStatus();
    const { mutate } = useLogout();

    const [menu, setMenu] = useState({});

    const handleLogout = useCallback(() => {
        mutate();
    })

    useEffect(()=>{
        // if(user && user.user_tp){
        //     switch(user.user_tp){
        //         case USER_TP.SUPER :
                    setMenu(getMenu('ADMIN','SUPER'));
        //             break;
        //         case USER_TP.ADMIN :
        //             setMenu(getMenu('ADMIN','ADMIN'));
        //             break;
        //         case USER_TP.MANAGE :
        //             setMenu(getMenu('ADMIN','MANAGE'));
        //             break;
        //         case USER_TP.USER :
        //             setMenu(getMenu('ADMIN','USER'));
        //             break;
        //         case USER_TP.NORMAL :
        //             setMenu(getMenu('ADMIN','NORMAL'));
        //             break;
        //         default :
                    // setMenu({})
        //             break;
        //     }
        // }
    // },[user])
    },[])

    return (
        <Drawer 
            variant="persistent"
            open={menuStatus!==undefined?menuStatus:true}
            transitionDuration={300}
        >
            <MenuLeft>
                <h2 onClick={()=>navigate('/')}>TSAS - TSS</h2>
                <div style={{flexGrow:1,width:'100%'}}>
                    <div style={{height:'1rem'}} />
                    {(menu && menu.main) &&
                        menu.main.map((mainMenu,index)=>
                            <React.Fragment key={index}>
                                <span onClick={()=>navigate(mainMenu.URL)}>{mainMenu.TEXT}</span>
                                <div>
                                {
                                    menu.sub.filter((temp)=>temp.P_MENU===mainMenu.ID).map((subMenu,sIdx)=>
                                        <span key={sIdx} onClick={()=>navigate(subMenu.URL)}>{subMenu.TEXT}</span>
                                    )
                                }
                                </div>
                                <div style={{height:'0.6rem'}} />
                            </React.Fragment>
                        )
                    }
                </div>
                {process.env.REACT_APP_RUN_MODE !== 'PROD' && <span>{process.env.REACT_APP_RUN_MODE}</span>}
                <div onClick={handleLogout} style={{cursor:'pointer'}}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2.75H18.12C18.9125 2.71467 19.6868 2.9947 20.2734 3.52881C20.86 4.06293 21.2111 4.80763 21.25 5.6V18.4C21.2111 19.1924 20.86 19.9371 20.2734 20.4712C19.6868 21.0053 18.9125 21.2853 18.12 21.25H12" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M15 12H2.78" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M2.75 12L6.75 16" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M2.75 12L6.75 8" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <div style={{height:'1rem'}} />
                <img src={`/images/logo.png`} style={{width:'4rem',marginBottom:'16px'}}/>
            </MenuLeft>
        </Drawer>
    )
}

export default Menu;